import type { StyleApplyMode } from "@/components/BgPresetPicker";

export type StylePresetBinding = {
  id: string;
  style_id?: string;
  visual_pack_id?: string;
};

/** Kafelek o tym samym stylu + paczce co zapisana seria (podświetlenie w trybie Tylko layout). */
export function presetIdForLayout(
  presets: StylePresetBinding[],
  styleId?: string | null,
  visualPackId?: string | null,
): string {
  const style = String(styleId || "").trim();
  const pack = String(visualPackId || "").trim();
  if (!style && !pack) return "";
  const hit = presets.find(
    (row) => String(row.style_id || "").trim() === style && String(row.visual_pack_id || "").trim() === pack,
  );
  return hit?.id || "";
}

export function buildTemplatePatchFromPreset(
  mode: StyleApplyMode,
  id: string,
  preset?: StylePresetBinding,
): {
  bg_preset_id?: string;
  layout_preset_id?: string;
  style_apply_mode: StyleApplyMode;
  style_id?: string;
  visual_pack_id?: string;
} {
  if (mode === "full" && id) {
    return {
      bg_preset_id: id,
      layout_preset_id: id,
      style_apply_mode: "full",
      style_id: preset?.style_id,
      visual_pack_id: preset?.visual_pack_id || "",
    };
  }
  if (mode === "layout" && id) {
    return {
      style_apply_mode: "layout",
      layout_preset_id: id,
      style_id: preset?.style_id,
      visual_pack_id: preset?.visual_pack_id || "",
    };
  }
  return {
    bg_preset_id: id,
    style_apply_mode: mode === "layout" ? "bg" : mode,
  };
}

export function styleApplyButtonLabel(mode: StyleApplyMode): string {
  if (mode === "full") return "Zastosuj tło + layout do serii";
  if (mode === "layout") return "Zastosuj layout do serii";
  return "Zapisz typ tła";
}

export function committedPresetId(
  mode: StyleApplyMode,
  presets: StylePresetBinding[],
  bgPresetId: string,
  styleId?: string | null,
  visualPackId?: string | null,
  layoutPresetId?: string | null,
): string {
  const layout = String(layoutPresetId || "").trim();
  if (mode === "layout") {
    if (layout) return layout;
    return presetIdForLayout(presets, styleId, visualPackId);
  }
  if (mode === "full") {
    return String(bgPresetId || layout || "").trim();
  }
  return bgPresetId || "";
}
